import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=369c68fb&scoped=true&"
import script from "./FAQComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQComponent.vue?vue&type=style&index=0&id=369c68fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c68fb",
  null
  
)

export default component.exports